module.exports = __webpack_public_path__ + "img/1101two2.0eff7229.png";